import api from '../auth';
const slug = "api/houses/";

const HouseService = () => {
    const getHouses = () => {
        return api.get(slug).then((res) => res.data);
    };

    const getHousesLazy = (params) => {
        return api
            .get(slug, {
                params
            })
            .then((res) => res.data);
    };

    const getHouse = (id) => {
        return api.get(slug + `show/${id}/`).then((res) => res.data);
    };

    const deleteHouse = (id) => {
        return api.delete(slug + `house/${id}/`)
        .then((res) => res.data)
        .catch((err) => {
            return err;
        });
    };

    const createHouse = (data) => {
        return api.post(slug, data).then((res) => res.data);
    };

    const updateHouse = (id, data) => {
        return api.put(slug + `house/${id}/`, data).then((res) => res.data);
    };

    const getOptions = () => {
        return api.options(slug).then((res) => res.data.actions.POST);
    };

    // custom action
    const copyHouse = (id) => {
        return api.post(slug + `copy/${id}/`).then((res) => res.data);
    };

    return {
        getHouses,
        getHousesLazy,
        getHouse,
        deleteHouse,
        createHouse,
        updateHouse,
        getOptions,
        copyHouse
    };
};

export default HouseService;




